import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import cn from 'classnames';
import useStyles from 'isomorphic-style-loader/useStyles';
import upperFirst from 'lodash/upperFirst';
import { useConversion } from 'hooks';
import * as selectors from 'modules/PatientResults/selectors';
import messages from 'modules/PatientResults/messages';
import { useGlucoseConcentrationLevels } from './hooks';
import BarChart from './BarChart';
import ScaleValues from './ScaleValues';
import Ranges from './Ranges';
import styles from './GlucoseConcentrationLevels.pcss';
const GlucoseConcentrationLevels = ({ readings, className, isInProgress = false, onAddNote })=>{
    const deviceMode = useSelector(selectors.deviceMode);
    const conversion = useConversion('bloodGlucoseConcentration');
    const glucoseConcentrationLevels = useGlucoseConcentrationLevels(readings, deviceMode === 'AGP');
    useStyles(styles);
    const isNotingActive = !!onAddNote;
    const onAddLevelNote = (evt, level)=>{
        evt.preventDefault();
        evt.stopPropagation();
        if (!isNotingActive) {
            return;
        }
        const noteType = `GlucoseConcentrationLevel${upperFirst(level.name)}`;
        const value = level.percentage;
        const rangeValue = `${conversion.toDisplay(level.bottomThreshold)} - ${conversion.toDisplay(level.topThreshold)}` + ` ${conversion.unitSymbol}`;
        const titleMessage = messages.glucoseConcentrationLevels.noteTitle;
        onAddNote(noteType, {
            value,
            unitSymbol: '%',
            rangeValue,
            status: level.name,
            titleMessage
        });
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: cn(styles.root, className, {
            fadingLoader: isInProgress
        }),
        children: [
            /*#__PURE__*/ _jsx(ScaleValues, {
                glucoseConcentrationLevels: glucoseConcentrationLevels,
                isNotingActive: isNotingActive,
                onAddLevelNote: onAddLevelNote
            }),
            /*#__PURE__*/ _jsx(BarChart, {
                glucoseConcentrationLevels: glucoseConcentrationLevels,
                isNotingActive: isNotingActive,
                isInProgress: isInProgress,
                onAddLevelNote: onAddLevelNote
            }),
            /*#__PURE__*/ _jsx(Ranges, {
                glucoseConcentrationLevels: glucoseConcentrationLevels,
                isNotingActive: isNotingActive,
                onAddLevelNote: onAddLevelNote
            })
        ]
    });
};
export default GlucoseConcentrationLevels;
